import type { ValueOf } from 'type-fest';
import type { DynamicImage } from '../dynamic-image/dynamic-image.types';
import type { EmbedVideo } from '../embed-video/embed-video.types';
import type { EmbedYoutube } from '../embed-youtube/embed-youtube.types';

export const themes = {
  paddedButtons: 'padded-buttons',
} as const;

export type Media = {
  buttonText: string;
  isPrimaryButton?: boolean;
  video?: EmbedVideo;
  youTube?: EmbedYoutube;
};

export type EmbedMedia = {
  error?: string;
  media: Media[];
  poster?: DynamicImage;
  theme?: ValueOf<typeof themes>;
};

export default EmbedMedia;
